/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import {FormGroup as BootstrapFormGroup, FormLabel, FormText} from 'react-bootstrap';
import Props from './Props';
import {ConstraintViolationDTO} from '../../model/validation';
import {css} from 'aphrodite/no-important';
import styles from './styles';

class FormGroup extends React.Component<Props> {

	static defaultProps: Partial<Props> = {
		controlId: '',
		label: '',
		violations: []
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<BootstrapFormGroup controlId={props.controlId} className={css(styles.formGroup)}>
				<FormLabel>{props.label}</FormLabel>
				{props.children}
				<FormText className="invalid-feedback">
					{props.violations?.map((violation: ConstraintViolationDTO, index: number) => {
						return <div key={index}>{violation.message}</div>;
					})}
				</FormText>
			</BootstrapFormGroup>
		);
	}
}

export default FormGroup;
